import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';
import {
    CodeBlock, BlockType, SettingType, Define, SettingState,
} from '@appblocks/codegeneration/types';

import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';

export default class Beep extends BaseFeature {
    constructor() {
        super();
        this.name = 'Beep';
        this.id = 'beep';
        this.requirements = ['rtc'];
        const settings = [
            {
                id: 'FREQUENCY',
                name: 'Frequency',
                settingType: SettingType.NUMBER,
                required: true,
                min: 2,
                max: 65535,
                default: '2700',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        const { project } = this;
        const FREQUENCY = this.getSettingValue('FREQUENCY');

        if (project.runtime === 'simulator') {
            return blocks;
        }

        if (project.device.platform === 'WM2000') {
            blocks.push({
                location: 'boot',
                blockType: BlockType.CODE,
                template: `beep.frequency=${FREQUENCY}`,
            });
        } else {
            const CLOCK = 120000000;
            const freq = Math.floor(CLOCK / (4 * FREQUENCY));
            blocks.push({
                location: 'boot',
                blockType: BlockType.CODE,
                template: `
    beep.divider = ${freq}`,
            });
        }

        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/object_beep_divider';
    }
}
